<!-- nosemgrep: python.django.security.django-no-csrf-token.django-no-csrf-token -- motivo: POST SAML hacia Salesforce, no es una plantilla Django; responsable: frontend; vence: 2027-10-31 -->
<form name="saml-logout-binding" method="post" action="{{configuracionSalesforce.logout_redirect_uri}}" #form>
  <input type="text" name="token" value="{{salesforceToken}}" hidden>
  <input type="text" name="callback" hidden value="{{urlCallbackLogout}}">
  <input type="text" size="100%" name="branding" hidden value="{{configuracionSalesforce.branding}}">
  <button (click)="form.submit(); sessionStorage.clear();"
          class="group flex w-full items-center gap-x-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 c-pointer hover:bg-gray-50 hover:text-gray-900">
    <svg aria-hidden="true" class="size-5 shrink-0 text-gray-400 group-hover:text-gray-500" fill="none" stroke="currentColor" stroke-width="1.5"
         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"/>
    </svg>
    {{ 'Cerrar sesión' | translate }}
  </button>
</form>
